import { Button } from "@package/subframe/components/Button";
import { IconWithLogoBackground } from "@package/subframe/components/IconWithLogoBackground";

import { Dialog, DialogContent } from "@/components/ui/dialog";

interface PublishSuccessDialogProps {
  open: boolean;
  templateName: string;
  onViewDashboard: () => void;
  onBackToTemplates: () => void;
}

export function PublishSuccessDialog({
  open,
  templateName,
  onViewDashboard,
  onBackToTemplates,
}: PublishSuccessDialogProps) {
  return (
    <Dialog open={open}>
      <DialogContent
        className="p-0 sm:max-w-[448px]"
        showCloseButton={false}
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <div className="flex w-full flex-col items-center gap-8 px-8 py-8">
          <div className="flex w-full flex-col items-center gap-6">
            <IconWithLogoBackground variant="success" size="x-large" />
            <span className="text-heading-2 font-heading-2 text-primary-navy-800">
              Template published
            </span>
            <span className="text-body font-body text-subtext-color text-center px-8">
              Your &quot;{templateName}&quot; template has been published and is
              now active. Practitioners will start receiving checklists
              according to the schedule.
            </span>
          </div>
          <div className="flex w-full items-center gap-4">
            <Button
              className="h-12 grow shrink-0 basis-0"
              variant="neutral-secondary"
              size="large"
              onClick={onViewDashboard}
            >
              View dashboard
            </Button>
            <Button
              className="h-12 grow shrink-0 basis-0"
              variant="brand-primary"
              size="large"
              onClick={onBackToTemplates}
            >
              Back to templates
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
